module.exports = __webpack_public_path__ + "img/oneOrange.2556a11d.png";